import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import ThematicSection from './ThematicSection';
import ImgBox from '../Box/ImgBox';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(() => ({
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  textAlign: 'center',
  position: 'relative',
  width: '100%',
  paddingBottom: '1%',
  marginTop: '40px',
  minHeight: '600px',
}));

const CustomContainer = styled('div')(() => ({
  bottom: 0,
  minHeight: '600px',
  position: 'relative',
  top: '0px',
  left: '0px',
  height: '600px',
  textAlign: 'center',
  background: 'transparent !important'
}));

const Text = styled('div')(() => ({
  position: 'absolute',
  bottom: '0',
  width: '100%',
  textAlign: 'center',
  color: '#F0F0F9 !important',
  textShadow: '2px 2px 6px #001',
  fontSize: '34px',
  opacity: '1',
  textTransform: 'uppercase',
  fontWeight: 'bold',
  background: 'transparent !important',

  '& *': {
    background: 'transparent !important',
    backgroundColor: 'transparent !important',
    color: '#F0F0F9 !important'
  }
}));

const Subtext = styled('div')(() => ({
  fontSize: '20px',
  color: '#F0F0F9 !important',
  textTransform: 'none',
  textDecoration: 'underline',
}));

const BackgroundImage = styled(ImgBox)(() => ({
  position: 'absolute',
  objectFit: 'contain',
  top: '0px',
  left: '0px',
  minWidth: '100%',
  height: '600px',
  zIndex: '0'
}));

// ----------------------------------------------------------------------

HeroSectionWithText.propTypes = {
  image: PropTypes.string,
  text: PropTypes.string,
  thematic: PropTypes.array,
};

export default function HeroSectionWithText({ image, text, thematic }) {

  return (
    <RootStyle className="printable">
      <BackgroundImage src={image} />
      <CustomContainer>
        <Text>
          <h1 style={{ fontSize: '34px' }}> {text}</h1>

          <Subtext>
            <ThematicSection items={thematic} />
          </Subtext>
        </Text>
      </CustomContainer>
    </RootStyle>
    // <Wrap>
    //   <Image image={image} imgfit={imgFit} className="printable">
    //     {/* { favorite && <Heart heartAction={() => {heartAction()}} size={48} favorite={isFavorite}/> } */}
    //   </Image>{' '}
    //   <Text>
    //     {text}
    //     <Subtext>{subtext}</Subtext>
    //   </Text>
    //   <ThematicSection items={thematic} />
    // </Wrap>
  );
}
